import * as React from 'react'
import * as styles from './EPGButton.module.scss'
import * as cn from 'classnames'

interface EPGButtonProps {
  label?: string
  url: string
  isPhablet: boolean
  requiresExtraPadding?: boolean
}

const EPGIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24">
    <path
      d="M 4,6 15,6" />
    <path
      d="m 18,6 2,0" />
    <path
      d="m 4,12 7,0" />
    <path
      d="m 14,12 6,0" />
    <path
      d="m 9,18 11,0" />
    <path
      d="m 4,18 2,0" />
  </svg>
)

const EPGButton = (props: EPGButtonProps) => {
  if (!props.label || !props.url) {
    return null
  }
  const label = props.label
  const target = props.url
  return (
    <a
      className={cn(styles.EPGButtonWrapper, 'tst-epg-button-wrapper',
        {
          [styles.isSticky]: !props.isPhablet,
          [styles.topPadded]: props.requiresExtraPadding //This is a massive hack to enable non-sibling stickiness with Bento sticky nav.
        })} href={target}>
      <button className={cn(styles.EPGButton, { [styles.isSticky]: !props.isPhablet })}>
        <EPGIcon />
        <span>{label}</span>
      </button>
    </a>
  )
}

export default EPGButton
